import { render, staticRenderFns } from "./lookSysStudent.vue?vue&type=template&id=86084622&scoped=true&"
import script from "./lookSysStudent.vue?vue&type=script&lang=js&"
export * from "./lookSysStudent.vue?vue&type=script&lang=js&"
import style0 from "./lookSysStudent.vue?vue&type=style&index=0&id=86084622&scoped=true&lang=scss&"
import style1 from "./lookSysStudent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86084622",
  null
  
)

export default component.exports